// @flow

// eslint-disable-next-line import/no-extraneous-dependencies
import {
  isArrayLike,
  isBoolean,
  isEmpty,
  isFunction,
  isNumber,
  isObjectLike,
  isString,
} from 'lodash';
import type { TFunction } from '@app/components/translation';
import type { Validator } from './index';

type Required = ({
  field?: string,
  t?: TFunction,
  text?: string,
  usePlural?: boolean,
}) => Validator;

const required: Required = ({
  field,
  t,
  text,
  usePlural = false,
}) => {
  if (!t && !text && !field) {
    throw new Error('Either text or both translation function and field must be provided for creating a required validation.');
  }

  return (value) => {
    let validationText;

    if (text) {
      validationText = text;
    } else {
      if (!field) {
        throw new Error('Field is mandatory for creating a required validation.');
      }

      if (!t || !isFunction(t)) {
        throw new Error('The translation function (t) is mandatory for creating a required validation.');
      }

      validationText = t('{field} {count, plural, one {is required} other {are required}}', {
        field,
        count: usePlural ? 2 : 1,
        _comment: 'The validation message for required fields.',
      });
    }

    if (isString(value)) {
      return value.trim() ? undefined : validationText;
    }

    if (isArrayLike(value) || isObjectLike(value)) {
      return isEmpty(value) ? validationText : undefined;
    }

    if (isBoolean(value) || isNumber(value)) {
      return undefined;
    }

    return value ? undefined : validationText;
  };
};

export default required;
